import {ActionButton as $b41412308e87d8d9$export$cfc7921d29ef7b80} from "../button/ActionButton.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Field as $adcd096854d27620$export$a455218a85c89869} from "../label/Field.mjs";
import $c2J0Y$intlStringsmjs from "./intlStrings.mjs";
import {Provider as $71dfb0e0358a12de$export$2881499e37b75b9a, useProvider as $71dfb0e0358a12de$export$693cdb10cec23617, useProviderProps as $71dfb0e0358a12de$export$521c373ccc32c300} from "../provider/Provider.mjs";
import "../tags_vars.css";
import $c2J0Y$tags_vars_cssmjs from "../tags_vars_css.mjs";
import {Tag as $9d679de5135d5833$export$3288d34c523a1192} from "./Tag.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useTagGroup as $c2J0Y$useTagGroup} from "react-aria/useTagGroup";
import {FocusRing as $c2J0Y$FocusRing} from "react-aria/FocusRing";
import {FocusScope as $c2J0Y$FocusScope} from "react-aria/FocusScope";
import {ListCollection as $c2J0Y$ListCollection} from "react-stately/private/list/ListCollection";
import {ListKeyboardDelegate as $c2J0Y$ListKeyboardDelegate} from "react-aria/ListKeyboardDelegate";
import $c2J0Y$react, {useRef as $c2J0Y$useRef, useState as $c2J0Y$useState, useMemo as $c2J0Y$useMemo, useCallback as $c2J0Y$useCallback, useEffect as $c2J0Y$useEffect} from "react";
import {useId as $c2J0Y$useId} from "react-aria/useId";
import {useLayoutEffect as $c2J0Y$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useListState as $c2J0Y$useListState} from "react-stately/useListState";
import {useLocale as $c2J0Y$useLocale} from "react-aria/I18nProvider";
import {useLocalizedStringFormatter as $c2J0Y$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {useResizeObserver as $c2J0Y$useResizeObserver} from "react-aria/private/utils/useResizeObserver";
import {useValueEffect as $c2J0Y$useValueEffect} from "react-aria/private/utils/useValueEffect";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 





















const $8811b88ab1333b3f$var$TAG_STYLES = {
    medium: {
        height: 24,
        margin: 4
    },
    large: {
        height: 30,
        margin: 5
    }
};
const $8811b88ab1333b3f$export$67ea30858aaf75e3 = /*#__PURE__*/ (0, $c2J0Y$react).forwardRef(function TagGroup(props, ref) {
    props = (0, $71dfb0e0358a12de$export$521c373ccc32c300)(props);
    props = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let { maxRows: maxRows, children: children, actionLabel: actionLabel, onAction: onAction, labelPosition: labelPosition, renderEmptyState: renderEmptyState = ()=>stringFormatter.format('noTags') } = props;
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let containerRef = (0, $c2J0Y$useRef)(null);
    let tagsRef = (0, $c2J0Y$useRef)(null);
    let { direction: direction } = (0, $c2J0Y$useLocale)();
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    let stringFormatter = (0, $c2J0Y$useLocalizedStringFormatter)((0, ($parcel$interopDefault($c2J0Y$intlStringsmjs))), '@react-spectrum/tag');
    let [isCollapsed, setIsCollapsed] = (0, $c2J0Y$useState)(maxRows != null);
    let state = (0, $c2J0Y$useListState)(props);
    let [tagState, setTagState] = (0, $c2J0Y$useValueEffect)({
        visibleTagCount: state.collection.size,
        showCollapseButton: false
    });
    let keyboardDelegate = (0, $c2J0Y$useMemo)(()=>{
        let collection = isCollapsed ? new (0, $c2J0Y$ListCollection)([
            ...state.collection
        ].slice(0, tagState.visibleTagCount)) : new (0, $c2J0Y$ListCollection)([
            ...state.collection
        ]);
        return new (0, $c2J0Y$ListKeyboardDelegate)({
            collection: collection,
            ref: tagsRef,
            direction: direction,
            orientation: 'horizontal'
        });
    }, [
        direction,
        isCollapsed,
        state.collection,
        tagState.visibleTagCount,
        tagsRef
    ]);
    // Remove onAction from props so it doesn't make it into useGridList.
    delete props.onAction;
    let { gridProps: gridProps, labelProps: labelProps, descriptionProps: descriptionProps, errorMessageProps: errorMessageProps } = (0, $c2J0Y$useTagGroup)({
        ...props,
        keyboardDelegate: keyboardDelegate
    }, state, tagsRef);
    let actionsId = (0, $c2J0Y$useId)();
    let actionsRef = (0, $c2J0Y$useRef)(null);
    let updateVisibleTagCount = (0, $c2J0Y$useCallback)(()=>{
        if (maxRows && maxRows > 0) {
            let computeVisibleTagCount = ()=>{
                // Refs can be null at runtime.
                let currContainerRef = containerRef.current;
                let currTagsRef = tagsRef.current;
                let currActionsRef = actionsRef.current;
                if (!currContainerRef || !currTagsRef || !currActionsRef || state.collection.size === 0) return {
                    visibleTagCount: 0,
                    showCollapseButton: false
                };
                // Count rows and show tags until we hit the maxRows.
                let tags = [
                    ...currTagsRef.children
                ];
                let currY = -Infinity;
                let rowCount = 0;
                let index = 0;
                let tagWidths = [];
                for (let tag of tags){
                    let { width: width, y: y } = tag.getBoundingClientRect();
                    if (y !== currY) {
                        currY = y;
                        rowCount++;
                    }
                    if (maxRows && rowCount > maxRows) break;
                    tagWidths.push(width);
                    index++;
                }
                // Remove tags until there is space for the collapse button and action button (if present) on the last row.
                let buttons = [
                    ...currActionsRef.children
                ];
                if (maxRows && buttons.length > 0 && rowCount >= maxRows && currContainerRef.parentElement) {
                    let buttonsWidth = buttons.reduce((acc, curr)=>acc += curr.getBoundingClientRect().width, 0);
                    buttonsWidth += $8811b88ab1333b3f$var$TAG_STYLES[scale].margin * 2 * buttons.length;
                    let end = direction === 'ltr' ? 'right' : 'left';
                    let containerEnd = currContainerRef.parentElement.getBoundingClientRect()[end];
                    let lastTagEnd = tags[index - 1]?.getBoundingClientRect()[end];
                    lastTagEnd += $8811b88ab1333b3f$var$TAG_STYLES[scale].margin;
                    let availableWidth = containerEnd - lastTagEnd;
                    while(availableWidth < buttonsWidth && index > 0){
                        availableWidth += tagWidths.pop();
                        index--;
                    }
                }
                return {
                    visibleTagCount: Math.max(index, 1),
                    showCollapseButton: index < state.collection.size
                };
            };
            setTagState(function*() {
                // Update to show all items.
                yield {
                    visibleTagCount: state.collection.size,
                    showCollapseButton: true
                };
                // Measure, and update to show the items until maxRows is reached.
                yield computeVisibleTagCount();
            });
        }
    }, [
        maxRows,
        setTagState,
        direction,
        scale,
        state.collection.size
    ]);
    (0, $c2J0Y$useResizeObserver)({
        ref: containerRef,
        onResize: updateVisibleTagCount
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $c2J0Y$useLayoutEffect)(updateVisibleTagCount, [
        children
    ]);
    (0, $c2J0Y$useEffect)(()=>{
        // Recalculate visible tags when fonts are loaded.
        document.fonts?.ready.then(()=>updateVisibleTagCount());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let visibleTags = (0, $c2J0Y$useMemo)(()=>[
            ...state.collection
        ].slice(0, isCollapsed ? tagState.visibleTagCount : state.collection.size), [
        isCollapsed,
        state.collection,
        tagState.visibleTagCount
    ]);
    let handlePressCollapse = ()=>{
        // Prevents button from losing focus if focusedKey got collapsed.
        state.selectionManager.setFocusedKey(null);
        setIsCollapsed((prevCollapsed)=>!prevCollapsed);
    };
    let showActions = tagState.showCollapseButton || actionLabel && onAction;
    let isEmpty = state.collection.size === 0;
    let containerStyle = (0, $c2J0Y$useMemo)(()=>{
        if (maxRows == null || !isCollapsed || isEmpty) return undefined;
        let maxHeight = ($8811b88ab1333b3f$var$TAG_STYLES[scale].height + $8811b88ab1333b3f$var$TAG_STYLES[scale].margin * 2) * maxRows;
        return {
            maxHeight: maxHeight,
            overflow: 'hidden'
        };
    }, [
        isCollapsed,
        maxRows,
        isEmpty,
        scale
    ]);
    return /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $c2J0Y$FocusScope), null, /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $adcd096854d27620$export$a455218a85c89869), {
        ...props,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        showErrorIcon: true,
        ref: domRef,
        elementType: "span",
        wrapperClassName: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-fieldWrapper', {
            'spectrum-Tags-fieldWrapper--positionSide': labelPosition === 'side'
        })
    }, /*#__PURE__*/ (0, $c2J0Y$react).createElement("div", {
        ref: containerRef,
        style: containerStyle,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-container', {
            'spectrum-Tags-container--empty': isEmpty
        })
    }, /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $c2J0Y$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $c2J0Y$react).createElement("div", {
        ref: tagsRef,
        ...gridProps,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags')
    }, visibleTags.map((item)=>/*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $9d679de5135d5833$export$3288d34c523a1192), {
            ...item.props,
            key: item.key,
            item: item,
            state: state
        }, item.rendered)), isEmpty && /*#__PURE__*/ (0, $c2J0Y$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-empty-state')
    }, renderEmptyState()))), showActions && !isEmpty && /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $71dfb0e0358a12de$export$2881499e37b75b9a), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $c2J0Y$react).createElement("div", {
        role: "group",
        ref: actionsRef,
        id: actionsId,
        "aria-label": stringFormatter.format('actions'),
        "aria-labelledby": `${gridProps.id} ${actionsId}`,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-actions')
    }, tagState.showCollapseButton && /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        isQuiet: true,
        onPress: handlePressCollapse,
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-actionButton')
    }, isCollapsed ? stringFormatter.format('showAllButtonLabel', {
        tagCount: state.collection.size
    }) : stringFormatter.format('hideButtonLabel')), actionLabel && onAction && /*#__PURE__*/ (0, $c2J0Y$react).createElement((0, $b41412308e87d8d9$export$cfc7921d29ef7b80), {
        isQuiet: true,
        onPress: ()=>onAction?.(),
        UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($c2J0Y$tags_vars_cssmjs))), 'spectrum-Tags-actionButton')
    }, actionLabel))))));
});


export {$8811b88ab1333b3f$export$67ea30858aaf75e3 as TagGroup};
//# sourceMappingURL=TagGroup.mjs.map
